module.exports = __webpack_public_path__ + "img/42.a6ce0cbb.jpg";